export default{
    state: {
        blogCarts: [
            {
                id: 1,
                image: require('@/assets/img/blog/Photo.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 2,
                image: require('@/assets/img/blog/Photo2.png'),
                titleCart: 'How fast can you order a car in Canada?'
            },
            {
                id: 3,
                image: require('@/assets/img/blog/Photo3.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 4,
                image: require('@/assets/img/blog/Photo4.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 5,
                image: require('@/assets/img/blog/Photo5.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 6,
                image: require('@/assets/img/blog/Photo6.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 7,
                image: require('@/assets/img/blog/Photo7.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 8,
                image: require('@/assets/img/blog/Photo8.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 9,
                image: require('@/assets/img/blog/Photo9.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 10,
                image: require('@/assets/img/blog/Photo5.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 11,
                image: require('@/assets/img/blog/Photo6.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 12,
                image: require('@/assets/img/blog/Photo7.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 13,
                image: require('@/assets/img/blog/Photo8.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 14,
                image: require('@/assets/img/blog/Photo9.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 15,
                image: require('@/assets/img/blog/Photo.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 16,
                image: require('@/assets/img/blog/Photo2.png'),
                titleCart: 'How fast can you order a car in Canada?'
            },
            {
                id: 17,
                image: require('@/assets/img/blog/Photo3.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
            {
                id: 18,
                image: require('@/assets/img/blog/Photo4.png'),
                titleCart: 'How to save on buying a car? Why is it better to buy from us'
            },
        ],
        inventoryCars: [
            {
                id: 1,
                titleCar: 'Porsche',
                titleModel: 'Panamera II Turbo S E-Hybrid',
                exterior: [
                    require('@/assets/img/inventory/porshe/Photo.png'),
                    require('@/assets/img/inventory/porshe/Photo2.png'),
                    require('@/assets/img/inventory/porshe/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/porshe/Photo4.png'),
                    require('@/assets/img/inventory/porshe/Photo5.png'),
                    require('@/assets/img/inventory/porshe/Photo6.png')
                ],
                    
                body: 'Sedan',
                transmission: 'Automatic',
                year: 2018,
                price: 150,
                kilometres: 20
            },
            {
                id: 2,
                titleCar: 'Mitsubishi',
                titleModel: 'Outlander III Restyling',
                exterior: [
                    require('@/assets/img/inventory/mitsubishi/Photo.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo2.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mitsubishi/Photo4.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo5.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo6.png')
                ],
                body: 'Hatchback',
                transmission: 'Automatic',
                year: 2016,
                price: 30,
                kilometres: 50
            },
            {
                id: 3,
                titleCar: 'Mercedes-Benz',
                titleModel: 'CLA I (C117, X117) 200',
                exterior: [
                    require('@/assets/img/inventory/mersedes/Photo.png'),
                    require('@/assets/img/inventory/mersedes/Photo2.png'),
                    require('@/assets/img/inventory/mersedes/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes/Photo4.png'),
                    require('@/assets/img/inventory/mersedes/Photo5.png'),
                    require('@/assets/img/inventory/mersedes/Photo6.png')
                ],
                body: 'Coupe',
                transmission: 'Manual',
                year: 2019,
                price: 130,
                kilometres: 35
            },
            {
                id: 4,
                titleCar: 'Mercedes-Benz',
                titleModel: 'W124 420',
                exterior: [
                    require('@/assets/img/inventory/mersedes2/Photo.png'),
                    require('@/assets/img/inventory/mersedes2/Photo2.png'),
                    require('@/assets/img/inventory/mersedes2/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes2/Photo4.png'),
                    require('@/assets/img/inventory/mersedes2/Photo5.png'),
                    require('@/assets/img/inventory/mersedes2/Photo6.png')
                ],
                body: 'Sedan',
                transmission: 'Manual',
                year: 2004,
                price: 6,
                kilometres: 120
            },
            {
                id: 5,
                titleCar: 'Mercedes-Benz',
                titleModel: 'E-Class III Restyling 230',
                exterior: [
                    require('@/assets/img/inventory/mersedes3/Photo.png'),
                    require('@/assets/img/inventory/mersedes3/Photo2.png'),
                    require('@/assets/img/inventory/mersedes3/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes3/Photo4.png'),
                    require('@/assets/img/inventory/mersedes3/Photo5.png'),
                    require('@/assets/img/inventory/mersedes3/Photo6.png')
                ],
                body: 'SUV',
                transmission: 'Automatic',
                year: 2010,
                price: 12,
                kilometres: 80
            },
            {
                id: 6,
                titleCar: 'Audi',
                titleModel: ' A7 I (4G) S-tronic',
                exterior: [
                    require('@/assets/img/inventory/audi/Photo.png'),
                    require('@/assets/img/inventory/audi/Photo2.png'),
                    require('@/assets/img/inventory/audi/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/audi/Photo4.png'),
                    require('@/assets/img/inventory/audi/Photo5.png'),
                    require('@/assets/img/inventory/audi/Photo6.png')
                ],
                body: 'Sedan',
                transmission: 'Automatic',
                year: 2014,
                price: 25,
                kilometres: 60
            },
            {
                id: 7,
                titleCar: 'Mercedes-Benz',
                titleModel: 'W124 420',
                exterior: [
                    require('@/assets/img/inventory/mersedes2/Photo.png'),
                    require('@/assets/img/inventory/mersedes2/Photo2.png'),
                    require('@/assets/img/inventory/mersedes2/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes2/Photo4.png'),
                    require('@/assets/img/inventory/mersedes2/Photo5.png'),
                    require('@/assets/img/inventory/mersedes2/Photo6.png')
                ],
                body: 'Sedan',
                transmission: 'Manual',
                year: 2006,
                price: 8,
                kilometres: 110
            },
            {
                id: 8,
                titleCar: 'Mercedes-Benz',
                titleModel: 'E-Class III Restyling 230',
                exterior: [
                    require('@/assets/img/inventory/mersedes3/Photo.png'),
                    require('@/assets/img/inventory/mersedes3/Photo2.png'),
                    require('@/assets/img/inventory/mersedes3/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes3/Photo4.png'),
                    require('@/assets/img/inventory/mersedes3/Photo5.png'),
                    require('@/assets/img/inventory/mersedes3/Photo6.png')
                ],
                body: 'SUV',
                transmission: 'Automatic',
                year: 2011,
                price: 15,
                kilometres: 90
            },
            {
                id: 9,
                titleCar: 'Audi',
                titleModel: 'A7 I (4G) S-tronic',
                exterior: [
                    require('@/assets/img/inventory/audi/Photo.png'),
                    require('@/assets/img/inventory/audi/Photo2.png'),
                    require('@/assets/img/inventory/audi/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/audi/Photo4.png'),
                    require('@/assets/img/inventory/audi/Photo5.png'),
                    require('@/assets/img/inventory/audi/Photo6.png')
                ],
                body: 'Sedan',
                transmission: 'Automatic',
                year: 2013,
                price: 20,
                kilometres: 65
            },
            {
                id: 10,
                titleCar: 'Porsche',
                titleModel: 'Panamera II Turbo S E-Hybrid',
                exterior: [
                    require('@/assets/img/inventory/porshe/Photo.png'),
                    require('@/assets/img/inventory/porshe/Photo2.png'),
                    require('@/assets/img/inventory/porshe/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/porshe/Photo4.png'),
                    require('@/assets/img/inventory/porshe/Photo5.png'),
                    require('@/assets/img/inventory/porshe/Photo6.png')
                ],
                body: 'Sedan',
                transmission: 'Automatic',
                year: 2018,
                price: 140,
                kilometres: 25
            },
            {
                id: 11,
                titleCar: 'Mitsubishi',
                titleModel: 'Outlander III Restyling',
                exterior: [
                    require('@/assets/img/inventory/mitsubishi/Photo.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo2.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mitsubishi/Photo4.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo5.png'),
                    require('@/assets/img/inventory/mitsubishi/Photo6.png')
                ],
                body: 'Hatchback',
                transmission: 'Automatic',
                year: 2016,
                price: 35,
                kilometres: 55
            },
            {
                id: 12,
                titleCar: 'Mercedes-Benz',
                titleModel: 'CLA I (C117, X117) 200',
                exterior: [
                    require('@/assets/img/inventory/mersedes/Photo.png'),
                    require('@/assets/img/inventory/mersedes/Photo2.png'),
                    require('@/assets/img/inventory/mersedes/Photo3.png')
                ],
                interior: [
                    require('@/assets/img/inventory/mersedes/Photo4.png'),
                    require('@/assets/img/inventory/mersedes/Photo5.png'),
                    require('@/assets/img/inventory/mersedes/Photo6.png')
                ],
                body: 'Coupe',
                transmission: 'Manual',
                year: 2020,
                price: 110,
                kilometres: 35
            }
        ]
    },
    mutations: {},
    actions: {},
    getters: {
        blogCarts(state){
            return state.blogCarts
        },
        inventoryCars(state){
            return state.inventoryCars
        },
        getBlogCartById: (state) => (id) => {
            return state.blogCarts.find(blogCart => blogCart.id === id)
        }

    },
}